import CryptoJs from 'crypto-js'

/**
 * 文件分片
 */
function readSlice (file: File, start: number, size: number): Promise<Uint8Array> {
  return new Promise<Uint8Array>((resolve, reject) => {
    const fileReader = new FileReader()
    const slice = file.slice(start, start + size)

    fileReader.onload = () => resolve(new Uint8Array(fileReader.result as any))
    fileReader.onerror = reject
    fileReader.readAsArrayBuffer(slice)
  })
}

/**
 * 获取文件加密后hash
 * @param file 文件
 * @param mode 加密方式 eg: SHA256、MD5
 */
export async function getFileCrypto (file: File, mode: string): Promise<string> {
  mode = mode.toUpperCase()
  let hash = CryptoJs.algo[mode].create()
  const sliceSize = 10_485_760 // 10 MiB
  let start = 0

  while (start < file.size) {
    const slice: Uint8Array = await readSlice(file, start, sliceSize)
    const wordArray = CryptoJs.lib.WordArray.create(slice)
    hash = hash.update(wordArray)
    start += sliceSize
  }

  hash.finalize()

  return hash._hash.toString()
}

/**
 * 获取字符串加密后hash
 * @param file 文件
 * @param mode 加密方式 eg: SHA256、MD5
 */
export function getStringCrypto (str: string, mode: string) {
  mode = mode.toUpperCase()
  return CryptoJs[mode](str).toString()
}
